/* Vuggis homepage animations & media */
(function () {
  if (window.Vuggis) return;
  var doc = document;
  doc.documentElement.classList.add('vg-js');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canHover = window.matchMedia('(hover: hover)').matches;
  var hasIO = 'IntersectionObserver' in window;
  function each(root, sel, fn) { Array.prototype.forEach.call(root.querySelectorAll(sel), fn); }
  function onView(el, enter, leave, th) {
    if (!hasIO) { enter(); return; }
    new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) enter(); else if (leave) leave(); }); }, { threshold: th || 0.2 }).observe(el);
  }
  function play(v) { try { var p = v.play(); if (p && p.catch) p.catch(function () {}); } catch (e) {} }

  var revealIO = hasIO && !reduce ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); revealIO.unobserve(e.target); } });
  }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }) : null;
  function reveal(root) {
    each(root, '[data-vg-reveal]:not(.is-in), [data-vg-inview]:not(.is-in)', function (el) { if (revealIO) revealIO.observe(el); else el.classList.add('is-in'); });
  }

  /* Snowflake crystal sprites (drawn once, reused) */
  var sprites = null;
  function buildSprites() {
    if (sprites) return sprites;
    sprites = [];
    var S = 96, R = 42;
    for (var k = 0; k < 3; k++) {
      var c = doc.createElement('canvas'); c.width = c.height = S;
      var x = c.getContext('2d');
      x.translate(S / 2, S / 2);
      x.strokeStyle = '#ffffff'; x.fillStyle = '#ffffff';
      x.lineCap = 'round'; x.lineJoin = 'round';
      x.shadowColor = 'rgba(255,255,255,.9)'; x.shadowBlur = 6;
      x.lineWidth = k === 2 ? 4 : 3.2;
      for (var i = 0; i < 6; i++) {
        x.save(); x.rotate(i * Math.PI / 3);
        x.beginPath(); x.moveTo(0, 0); x.lineTo(0, -R); x.stroke();
        if (k === 0) {
          [[0.42, 0.3], [0.68, 0.24]].forEach(function (b) {
            var y = -R * b[0], l = R * b[1];
            x.beginPath(); x.moveTo(0, y); x.lineTo(-l * 0.7, y - l * 0.7); x.moveTo(0, y); x.lineTo(l * 0.7, y - l * 0.7); x.stroke();
          });
        } else if (k === 1) {
          var y1 = -R * 0.55, l1 = R * 0.32;
          x.beginPath(); x.moveTo(0, y1); x.lineTo(-l1 * 0.8, y1 - l1 * 0.55); x.moveTo(0, y1); x.lineTo(l1 * 0.8, y1 - l1 * 0.55); x.stroke();
          x.beginPath(); x.moveTo(0, -R - 1); x.lineTo(-5, -R + 6); x.lineTo(0, -R + 12); x.lineTo(5, -R + 6); x.closePath(); x.fill();
        } else {
          x.beginPath(); x.moveTo(0, -R * 0.78); x.lineTo(-R * 0.18, -R * 0.94); x.moveTo(0, -R * 0.78); x.lineTo(R * 0.18, -R * 0.94); x.stroke();
          x.beginPath(); x.moveTo(-R * 0.16, -R * 0.36); x.lineTo(0, -R * 0.24); x.lineTo(R * 0.16, -R * 0.36); x.stroke();
        }
        x.restore();
      }
      x.beginPath();
      for (var j = 0; j < 6; j++) { var a = j * Math.PI / 3; x[j ? 'lineTo' : 'moveTo'](Math.sin(a) * 7, -Math.cos(a) * 7); }
      x.closePath(); x.lineWidth = 2.4; x.stroke();
      sprites.push(c);
    }
    return sprites;
  }

  function snow(canvas) {
    if (canvas._vg || reduce) return; canvas._vg = 1;
    var ctx = canvas.getContext('2d'); if (!ctx) return;
    var spr = buildSprites();
    var dpr = Math.min(window.devicePixelRatio || 1, 2), w = 0, h = 0, flakes = [], raf = 0, on = false;
    function flake(init) {
      var depth = Math.random();
      var r = 3 + depth * depth * 11;
      return { x: Math.random() * w, y: init ? Math.random() * h : -r * 2, r: r, s: 0.25 + r * 0.055 + Math.random() * 0.2,
        d: Math.random() * 6.28, sw: 0.25 + Math.random() * 0.5, o: 0.45 + depth * 0.5, a: Math.random() * 6.28,
        va: (Math.random() - 0.5) * 0.02, k: Math.floor(Math.random() * spr.length) };
    }
    function size() {
      w = canvas.clientWidth; h = canvas.clientHeight; canvas.width = w * dpr; canvas.height = h * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      var n = Math.round(Math.min(110, (w * h) / 11000)); flakes = []; for (var i = 0; i < n; i++) flakes.push(flake(true));
    }
    function tick() {
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0); ctx.clearRect(0, 0, w, h);
      for (var i = 0; i < flakes.length; i++) {
        var f = flakes[i]; f.d += 0.01; f.y += f.s; f.x += Math.sin(f.d) * f.sw; f.a += f.va;
        if (f.y > h + f.r * 2) flakes[i] = f = flake(false);
        ctx.setTransform(dpr, 0, 0, dpr, f.x * dpr, f.y * dpr); ctx.rotate(f.a);
        ctx.globalAlpha = f.o; ctx.drawImage(spr[f.k], -f.r, -f.r, f.r * 2, f.r * 2);
      }
      ctx.globalAlpha = 1;
      if (on) raf = requestAnimationFrame(tick);
    }
    size(); var t; window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(size, 200); });
    onView(canvas, function () { if (!on) { on = true; raf = requestAnimationFrame(tick); } }, function () { on = false; cancelAnimationFrame(raf); }, 0);
  }

  function countdown(el) {
    if (el._vg) return; el._vg = 1;
    var target = new Date(el.getAttribute('data-vg-countdown')).getTime();
    if (isNaN(target)) { el.hidden = true; return; }
    var q = function (s) { return el.querySelector(s); }, D = q('[data-d]'), H = q('[data-h]'), M = q('[data-m]'), S = q('[data-s]');
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function upd() {
      var diff = target - Date.now(); if (diff <= 0) { el.hidden = true; clearInterval(timer); return; }
      var s = Math.floor(diff / 1000);
      D.textContent = pad(Math.floor(s / 86400)); H.textContent = pad(Math.floor(s % 86400 / 3600)); M.textContent = pad(Math.floor(s % 3600 / 60)); S.textContent = pad(s % 60);
    }
    var timer = setInterval(upd, 1000); upd();
  }

  function autoVideos(root) {
    each(root, '[data-vg-autowrap] video', function (v) {
      if (v._vg) return; v._vg = 1;
      v.muted = true; v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.playsInline = true; v.loop = true; v.removeAttribute('controls');
      if (reduce) { v.removeAttribute('autoplay'); v.pause(); return; }
      onView(v, function () { if (v.preload === 'none') v.preload = 'metadata'; play(v); }, function () { v.pause(); }, 0.2);
    });
  }

  function hoverVideos(root) {
    each(root, '[data-vg-hover]', function (card) {
      if (card._vgh) return; card._vgh = 1;
      var v = card.querySelector('video'); if (!v || reduce) return;
      v.muted = true; v.playsInline = true; v.loop = true; v.setAttribute('playsinline', ''); v.removeAttribute('controls');
      if (canHover) {
        card.addEventListener('mouseenter', function () { v.preload = 'auto'; play(v); card.classList.add('is-playing'); });
        card.addEventListener('mouseleave', function () { v.pause(); card.classList.remove('is-playing'); });
      } else {
        onView(card, function () { v.preload = 'auto'; play(v); card.classList.add('is-playing'); }, function () { v.pause(); }, 0.5);
      }
    });
  }

  function tilt(el) {
    if (el._vg || reduce || !canHover) return; el._vg = 1;
    el.addEventListener('mousemove', function (e) {
      var r = el.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
      el.style.transform = 'perspective(900px) rotateY(' + (x * 8).toFixed(2) + 'deg) rotateX(' + (-y * 8).toFixed(2) + 'deg) translateY(-6px)';
    });
    el.addEventListener('mouseleave', function () { el.style.transform = ''; });
  }

  function parallax(el) {
    if (el._vg || reduce) return; el._vg = 1;
    var busy = false, host = el.parentElement;
    function upd() {
      var r = host.getBoundingClientRect();
      if (r.bottom > 0 && r.top < window.innerHeight) el.style.transform = 'translate3d(0,' + (Math.max(0, -r.top) * 0.3).toFixed(1) + 'px,0)';
      busy = false;
    }
    window.addEventListener('scroll', function () { if (!busy) { busy = true; requestAnimationFrame(upd); } }, { passive: true }); upd();
  }

  function ugc(sec) {
    if (sec._vg) return; sec._vg = 1;
    var rail = sec.querySelector('[data-vg-rail]');
    each(sec, '[data-vg-dir]', function (b) {
      b.addEventListener('click', function () {
        if (!rail) return; var card = rail.querySelector('.vg-reel'); var step = card ? card.getBoundingClientRect().width + 16 : 300;
        rail.scrollBy({ left: step * Number(b.getAttribute('data-vg-dir')), behavior: 'smooth' });
      });
    });
    var modal = sec.querySelector('[data-vg-modal]'); if (!modal) return;
    if (modal.parentElement !== doc.body) doc.body.appendChild(modal);
    var box = modal.querySelector('[data-vg-modal-video]'), last = null;
    function close() {
      modal.classList.remove('is-open'); doc.documentElement.style.overflow = '';
      var v = box.querySelector('video'); if (v) v.pause();
      setTimeout(function () { box.innerHTML = ''; }, 350); if (last) last.focus();
    }
    each(sec, '[data-vg-open]', function (card) {
      function open(e) {
        if (e && e.target.closest && e.target.closest('a')) return;
        var src = card.querySelector('video'); if (!src) return;
        var s = src.currentSrc || (src.querySelector('source') || {}).src || src.src; if (!s) return;
        var v = doc.createElement('video');
        v.src = s; v.controls = true; v.loop = true; v.playsInline = true; v.setAttribute('playsinline', ''); v.autoplay = true; if (src.poster) v.poster = src.poster;
        box.innerHTML = ''; box.appendChild(v); last = card;
        modal.classList.add('is-open'); doc.documentElement.style.overflow = 'hidden'; play(v);
        var c = modal.querySelector('[data-vg-close]'); if (c) c.focus();
      }
      card.addEventListener('click', open);
      card.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); } });
    });
    modal.addEventListener('click', function (e) { if (e.target === modal || e.target.closest('[data-vg-close]')) close(); });
    doc.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal.classList.contains('is-open')) close(); });
  }

  function ship(sec) {
    if (sec._vg) return; sec._vg = 1;
    var steps = sec.querySelectorAll('[data-vg-step]'), n = steps.length; if (!n) return;
    var today = new Date(); today.setHours(0, 0, 0, 0); var active = -1;
    Array.prototype.forEach.call(steps, function (s, i) {
      var raw = (s.getAttribute('data-vg-step') || '').trim(); if (!raw) return;
      var d = new Date(raw + 'T23:59:59'); if (isNaN(d)) return;
      if (d < today) s.classList.add('is-past'); else if (active < 0) { active = i; s.classList.add('is-active'); }
    });
    var pct = active < 0 ? 100 : (n > 1 ? (active / (n - 1)) * 100 : 0);
    sec.style.setProperty('--progress', pct + '%');
  }

  doc.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-vg-sound]'); if (!b) return;
    var scope = b.closest('[data-vg-sound-scope]'); var v = scope && scope.querySelector('video'); if (!v) return;
    v.muted = !v.muted; if (!v.muted) play(v);
    b.classList.toggle('is-on', !v.muted); b.setAttribute('aria-label', v.muted ? 'Unmute video' : 'Mute video');
  });

  function init(root) {
    root = root || doc;
    reveal(root);
    each(root, '[data-vg-snow]', snow);
    each(root, '[data-vg-countdown]', countdown);
    autoVideos(root); hoverVideos(root);
    each(root, '[data-vg-tilt]', tilt);
    each(root, '[data-vg-parallax]', parallax);
    each(root, '[data-vg-ugc]', ugc);
    each(root, '[data-vg-ship]', ship);
  }
  window.Vuggis = { init: init };
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { init(doc); }); else init(doc);
  doc.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();